import { POSTS_FRONT_EDITOR_RENDERER_TOOL_LIST } from "@raiden/library/constants/editeur";
import { BLOCK_FILES_IMAGE } from "@raiden/library/containers/Files/EditorImage/BlockData";
import {
  ContentRenderer,
  RendererChakra,
} from "@splitfire-agency/raiden-le-editeur/dist/renderers";
import { FilesEditorImageBlockChakra } from "@raiden/library/containers/Files/EditorImage/BlockChakra";
import useLocale from "@raiden/library/hooks/useLocale";
import { LOCALES_LANG_NAMES } from "@raiden/library/constants/locales";

const TOOLS = [
  ...POSTS_FRONT_EDITOR_RENDERER_TOOL_LIST,
  {
    name: "Image",
    block: BLOCK_FILES_IMAGE,
    component: FilesEditorImageBlockChakra,
  },
];

/**
 * @typedef {Object} Props
 * @property {any} content
 */
/**
 * @param {Props} props
 */
export function CustomContentRenderer({ content }) {
  const { locale, defaultLocale } = useLocale();

  const language = {
    name: LOCALES_LANG_NAMES[locale ?? defaultLocale].name,
    key: locale ?? defaultLocale,
  };

  return (
    <ContentRenderer
      tools={TOOLS}
      language={language}
      renderer={RendererChakra}
      document={content}
    />
  );
}
